const STATE_KEY = 'employeeInspector';

// One history entry per open panel, including while its employee is reloaded.
function createEmployeeInspectorHistory(browser, close) {
    let token = null;
    let url = null;
    let returning = false;
    let destroyed = false;
    function onPopState(event) {
        if (returning) {
            returning = false;
            if (browser.location.href === url) event.stopImmediatePropagation();
            if (destroyed) browser.removeEventListener('popstate', onPopState, true);
            return;
        }
        if (!token || event.state && event.state[STATE_KEY] === token) return;
        token = null;
        // Consume only the panel's same-page entry, before page-level back handlers.
        if (browser.location.href === url) event.stopImmediatePropagation();
        close();
    }
    browser.addEventListener('popstate', onPopState, true);
    return {
        open() {
            if (token) return;
            const nextToken = `${Date.now()}:${Math.random().toString(36).slice(2)}`;
            try {
                browser.history.pushState({
                    ...browser.history.state, [STATE_KEY]: nextToken
                }, '', browser.location.href);
                token = nextToken;
                url = browser.location.href;
            } catch (error) {
                // The panel remains usable when the browser disallows history writes.
            }
        },
        close() {
            const active = token && browser.history.state
                && browser.history.state[STATE_KEY] === token
                && browser.location.href === url;
            token = null;
            if (active) {
                returning = true;
                browser.history.back();
            }
        },
        destroy() {
            destroyed = true;
            this.close();
            if (!returning) browser.removeEventListener('popstate', onPopState, true);
        }
    };
}

module.exports = {createEmployeeInspectorHistory};
